import {
  MAT_COLOR_FORMATS,
  NgxMatColorPickerModule,
  NGX_MAT_COLOR_FORMATS,
} from "@angular-material-components/color-picker";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatTabsModule } from "@angular/material/tabs";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslateModule } from "@ngx-translate/core";
import { CategoriesModule } from "src/app/shared/modules/categories/categories.module";
import { CustomTableModule } from "src/app/shared/modules/custom-table/custom-table.module";
import { TopCardMaterialModule } from "src/app/shared/modules/top-card-material/top-card-material.module";
import { FormatPipe } from "src/app/shared/pipes/formatPipe";
import { ProductPriceSchedulingRoutingModule } from "./product-price-scheduling-routing.module";
import { ProductPriceSchedulingListComponent } from "./product-price-scheduling-list/product-price-scheduling-list.component";
import { ProductPriceSchedulingDetailComponent } from "./product-price-scheduling-detail/product-price-scheduling-detail.component";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { DateTimeModule } from "src/app/shared/modules/date-time/date-time.module";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatTableModule } from "@angular/material/table";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    ProductPriceSchedulingRoutingModule,
    CustomTableModule,
    TopCardMaterialModule,
    MatProgressBarModule,
    FlexLayoutModule,
    NgxMatColorPickerModule,
    MatCardModule,
    MatIconModule,
    MatTabsModule,
    MatButtonModule,
    MatInputModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatAutocompleteModule,
    CategoriesModule,
    DateTimeModule,
    MatSlideToggleModule,
    MatTableModule,
  ],
  providers: [
    { provide: MAT_COLOR_FORMATS, useValue: NGX_MAT_COLOR_FORMATS },
    FormatPipe,
  ],

  declarations: [ProductPriceSchedulingListComponent, ProductPriceSchedulingDetailComponent],
  exports: [ProductPriceSchedulingListComponent]
})
export class ProductPriceSchedulingModule {}
